import { useId } from 'react';

import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
};

export const Target = ({ size = 2 }: Props) => {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3.19998C15.3078 3.19998 18.8 6.69215 18.8 11C18.8 15.3078 15.3078 18.8 11 18.8C6.69213 18.8 3.19995 15.3078 3.19995 11C3.19995 6.69215 6.69213 3.19998 11 3.19998ZM10.999 6.28843C13.6016 6.28843 15.7115 8.39829 15.7115 11.0009C15.7115 13.6036 13.6016 15.7134 10.999 15.7134C8.39636 15.7134 6.2865 13.6036 6.2865 11.0009C6.2865 8.39829 8.39636 6.28843 10.999 6.28843Z"
        fill={`url(#${id})`}
      />
      <path
        d="M12.3012 16.1993L12.3012 21.3993H9.70122L9.70122 16.1993H12.3012Z"
        fill={`url(#${id})`}
      />
      <path
        d="M0.600586 12.2987L5.80059 12.2987V9.69871H0.600586V12.2987Z"
        fill={`url(#${id})`}
      />
      <path
        d="M21.4 12.2987L16.2 12.2987V9.69871H21.4L21.4 12.2987Z"
        fill={`url(#${id})`}
      />
      <path
        d="M12.3012 0.599976L12.3012 5.79998H9.70122L9.70122 0.599977L12.3012 0.599976Z"
        fill={`url(#${id})`}
      />
      <path
        d="M10.7164 13.3372C11.016 12.9636 11.4022 12.6686 11.8414 12.4776C12.2806 12.2865 12.7596 12.2049 13.2371 12.24C13.2565 12.2422 13.2758 12.2386 13.2932 12.2302C13.3106 12.2218 13.3253 12.2084 13.3354 12.1918C13.3454 12.1752 13.3506 12.1562 13.3501 12.1369C13.3498 12.1175 13.3438 12.0988 13.3332 12.0824C13.0706 11.6819 12.9095 11.2233 12.8635 10.7466C12.8175 10.2698 12.888 9.78896 13.0692 9.34567C13.0763 9.32799 13.0785 9.30894 13.0752 9.29016C13.072 9.27138 13.0638 9.25397 13.0513 9.23982C13.0388 9.22567 13.0224 9.21533 13.0042 9.20988C12.986 9.20444 12.9666 9.20417 12.9484 9.20907C12.4858 9.33561 11.9992 9.34731 11.5309 9.24363C11.0626 9.13995 10.6266 8.92388 10.2606 8.61393C10.2459 8.60196 10.2282 8.59407 10.2095 8.59134C10.1907 8.58862 10.1716 8.59134 10.1542 8.59896C10.1368 8.60658 10.1218 8.61856 10.111 8.63434C10.1001 8.65012 10.0938 8.66808 10.0925 8.68713C10.0693 9.16525 9.93026 9.63086 9.68726 10.0434C9.44425 10.4559 9.10463 10.8032 8.69781 11.0552C8.68175 11.0652 8.66896 11.0797 8.66052 11.0968C8.65209 11.1139 8.64882 11.1327 8.65046 11.1518C8.65236 11.1705 8.65916 11.1888 8.67059 11.2037C8.68202 11.219 8.69753 11.2307 8.71495 11.2375C9.16314 11.407 9.56344 11.683 9.88128 12.0416C10.1991 12.4003 10.4247 12.831 10.5387 13.2964C10.5431 13.3149 10.5526 13.3315 10.5662 13.3448C10.5798 13.3582 10.5967 13.3674 10.6149 13.3715C10.6334 13.3756 10.6528 13.3748 10.6704 13.3685C10.6884 13.3622 10.7045 13.3519 10.7164 13.3372Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          id={id}
          x1="17.259"
          y1="19.3052"
          x2="4.74158"
          y2="2.6941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D49E3C" />
          <stop offset="1" stopColor="#FF4E22" />
        </linearGradient>
      </defs>
    </svg>
  );
};
